import React, { useState, useEffect, useRef } from 'react';
import './Services.css';

const Services = () => {
  const [openItems, setOpenItems] = useState({});
  const [closingItems, setClosingItems] = useState({});
  const [openingItems, setOpeningItems] = useState({});
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Анимация только один раз
        }
      },
      {
        threshold: 0.1, // Запускаем когда 10% элемента видимо
        rootMargin: '0px 0px -100px 0px' // Немного раньше чем элемент появится
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const toggleItem = (itemId) => {
    if (openItems[itemId]) {
      // Начинаем закрытие
      setClosingItems(prev => ({ ...prev, [itemId]: true }));
      setOpeningItems(prev => {
        const newState = { ...prev };
        delete newState[itemId];
        return newState;
      });
      
      // Через время анимации убираем из openItems
      setTimeout(() => {
        setOpenItems(prev => {
          const newState = { ...prev };
          delete newState[itemId];
          return newState;
        });
        setClosingItems(prev => {
          const newState = { ...prev };
          delete newState[itemId];
          return newState;
        });
      }, 400); // Увеличено время под CSS transition
    } else {
      // Открываем
      setOpenItems(prev => ({
        ...prev,
        [itemId]: true
      }));
      
      // Плавное появление через небольшую задержку
      setTimeout(() => {
        setOpeningItems(prev => ({
          ...prev,
          [itemId]: true
        }));
      }, 10);
    }
  };

  const services = [
    {
      id: '01',
      title: '1 ТАРИФ',
      details: [
        'Обмерный план',
        'План демонтажа',
        'План монтажа',
        'План расстановки мебели и оборудования',
        'План размещения сантехнического оборудования и канализации',
        'План потолков',
        'План напольных покрытий',
        'План размещения теплого пола',
        'План расстановки плинтусов',
        'План размещения электроустановочный изделий с мебелью',
        'План размещения электроустановочный изделий с размерами',
        'План размещения светильников и выключателей',
        'План размещения размещения групп включения освещения с мебелью',
        'План размещения кондиционеров',
        'Ведомость дверных проемов',
        'Ведомость отделки помещений (площадь материалов во всем помещении)',
        'Визуализации'
      ],
      // price: '3000 рублей м²'
    },
    {
      id: '02',
      title: '2 ТАРИФ',
      details: [
        'Обмерный план',
        'План демонтажа',
        'План монтажа',
        'План расстановки мебели и оборудования',
        'План размещения сантехнического оборудования и канализации',
        'План потолков',
        'План напольных покрытий',
        'План размещения теплого пола (при необходимости)',
        'План расстановки плинтусов',
        'План размещения электроустановочный изделий с мебелью',
        'План размещения электроустановочный изделий с размерами',
        'План размещения светильников и выключателей',
        'План размещения размещения групп включения освещения с мебелью',
        'План размещения кондиционеров',
        'Ведомость дверных проемов',
        'Ведомость отделки помещений (площадь материалов во всем помещении)',
        'Развертки всех помещений',
        'Визуализации',
        'Таблица с использованными чистовыми материалами, мебелью (не комплектация)'
      ],
      // price: '3500 рублей м²'
    },
    {
      id: '03',
      title: '3 ТАРИФ',
      details: [
        'Обмерный план',
        'План демонтажа',
        'План монтажа',
        'План расстановки мебели и оборудования',
        'План размещения сантехнического оборудования и канализации',
        'План потолков',
        'План напольных покрытий',
        'План размещения теплого пола (при необходимости)',
        'План расстановки плинтусов',
        'План размещения электроустановочный изделий с мебелью',
        'План размещения электроустановочный изделий с размерами',
        'План размещения светильников и выключателей',
        'План размещения размещения групп включения освещения с мебелью',
        'План размещения кондиционеров',
        'Ведомость дверных проемов',
        'Ведомость отделки помещений (площадь материалов во всем помещении)',
        'Развертки всех помещений',
        'Визуализации',
        'Комплектация - подбор чистовых материалов, мебели, сантехники, техники, осветительных приборов, дверей, радиаторов (без выездов в магазины с заказчиком и приемки на объекте)'
      ],
      // price: '4000 рублей м²'
    },
    {
      id: '04',
      title: 'АВТОРСКИЙ НАДЗОР',
      details: [
        'Подбор чистовых материалов',
        'Выезды на объект 2 раза в неделю',
        'Общение со строителями',
        'Консультирование по возникшим вопросам в процессе ремонта'
      ],
      // price: 'От 25 000 тысяч рублей в месяц (Зависит от площади квартиры и ее местоположения)'
    },
    {
      id: '05',
      title: 'КОМПЛЕКТАЦИЯ',
      details: [
        'Подбор чистовых материалов, мебели, сантехники, техники, осветительных приборов, дверей, радиаторов',
        'Осуществление заказа и доставки всего перечисленного',
        'Приемка на объекте 1 раз в неделю'
      ],
      // price: 'От 30 000 тысяч рублей за услугу (Зависит от площади квартиры и ее местоположения)'
    }
  ];

  return (
    <section id="services" className="services" ref={sectionRef}>
      <div className="services-container">
        <h2 className={`services-title ${isVisible ? 'animate' : ''}`}>УСЛУГИ</h2>
        
        <div className="services-list">
          {services.map((service) => (
            <div key={service.id} className={`service-item ${isVisible ? 'animate' : ''}`}>
              <div 
                className="service-row"
                onClick={() => toggleItem(service.id)}
              >
                <div className="service-number">{service.id}</div>
                <h3 className="service-title">{service.title}</h3>
                <div className={`service-arrow ${(openingItems[service.id] && !closingItems[service.id]) ? 'open' : ''}`}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
              
              {(openItems[service.id] || closingItems[service.id]) && (
                <div className={`service-details ${openingItems[service.id] ? 'opening' : ''} ${closingItems[service.id] ? 'closing' : ''}`}>
                  <div className="service-content">
                    <ul className="service-list">
                      {service.details.map((detail, index) => (
                        <li key={index} className="service-list-item">{detail}</li>
                      ))}
                    </ul>
                    <div className="service-price">{service.price}</div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 
